export function kmMask(km) {
  let formattedValue = km;

  formattedValue = formattedValue.replace(/\D/g, '');
  formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formattedValue} km`;
}

export function kmMaskNoSuffix(km) {
  let formattedValue = km;

  formattedValue = formattedValue.replace(/\D/g, '');
  formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return formattedValue;
}
